// Welle U10: öffentliche Seiten /impressum und /datenschutzerklaerung — ohne Anmeldung.
// Wird in index.tsx VOR <App/> gewählt, damit keine App-Logik (Token, History, Abrufe) läuft.
import React, { useEffect } from 'react';
import { DatenschutzerklaerungText, ImpressumText, RechtsLinks } from './RechtsTexte';

export type RechtlicheArt = 'impressum' | 'datenschutzerklaerung';

export function rechtlicheSeiteFuerPfad(pfad: string): RechtlicheArt | null {
  const p = pfad.replace(/\/+$/, '').toLowerCase();
  if (p === '/impressum') return 'impressum';
  if (p === '/datenschutzerklaerung') return 'datenschutzerklaerung';
  return null;
}

export function RechtlicheSeite({ art }: { art: RechtlicheArt }) {
  const titel = art === 'impressum' ? 'Impressum' : 'Datenschutzerklärung';
  useEffect(() => { document.title = `${titel} · LehrerDesk`; }, [titel]);
  return (
    <div style={{ minHeight: '100vh', background: 'var(--ld-surface-page-gradient)', padding: '32px 16px 48px', boxSizing: 'border-box' }}>
      <main style={{ maxWidth: 760, margin: '0 auto' }}>
        <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: 'var(--ld-text-primary)', marginBottom: 24 }}>
          <span style={{ width: 36, height: 36, borderRadius: 11, background: 'var(--ld-primary)', display: 'grid', placeItems: 'center' }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
              <rect x="2" y="3" width="20" height="14" rx="2" stroke="white" strokeWidth="2" />
              <path d="M8 21h8M12 17v4" stroke="white" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </span>
          <span style={{ fontSize: 17, fontWeight: 800, letterSpacing: -0.2 }}>LehrerDesk</span>
        </a>
        <div style={{ background: 'var(--ld-bg-card)', borderRadius: 'var(--ld-radius-xl)', boxShadow: 'var(--ld-shadow-md)', padding: 'clamp(20px, 5vw, 36px)' }}>
          <h1 style={{ margin: '0 0 20px', fontSize: 28, fontWeight: 800, color: 'var(--ld-text-primary)', letterSpacing: '-0.02em' }}>{titel}</h1>
          {art === 'impressum' ? <ImpressumText /> : <DatenschutzerklaerungText />}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 12, marginTop: 20 }}>
          <a href="/" style={{ fontSize: 13, fontWeight: 600, color: 'var(--ld-accent)' }}>Zu LehrerDesk</a>
          <RechtsLinks ausrichtung="flex-start" />
        </div>
      </main>
    </div>
  );
}
